import { SHAPE_STYLES, TEXT_STYLE } from './constants';
import { addGameObject, anchoredPos, getZeroStaticEntity, setParent } from './entity';
import { v2 } from './helpers';
import { ObjectType } from './shared/api_shared_types';
import { setVisibilityState } from './simulate';
import { createAndAddLocalTextObject } from './textobject/textobject';
import {
  Entity,
  VisibilityState,
  GameManager,
  MoveMode,
  Shape,
  GameObjectController,
  ProgressMeter,
} from './types';

export function controller(): GameObjectController {
  return {
    getNew: null,
    sync: null,
    update: null,
  };
}

export function createProgressMeter(
  manager: GameManager,
  ent: Entity,
  label: string,
  value: number,
): ProgressMeter {
  let newMeter: ProgressMeter = {
    ...ent,
    objectType: ObjectType.PROGRESS_METER,
    label,
    labelText: null,
    minValue: 0,
    maxValue: 10,
    value,
    valuePercentage: 0, //0-1
    styleBackground: SHAPE_STYLES.PROGRESS_BACKGROUND,
    styleBackgroundHL: SHAPE_STYLES.PROGRESS_BACKGROUND_HL,
    styleFill: SHAPE_STYLES.PROGRESS_FILL,
  };

  newMeter.shape = Shape.RECT;
  newMeter.width = 140;
  newMeter.height = 28;
  newMeter.allowDrag = false;
  newMeter.influenceKinetic = false;
  newMeter.valuePercentage = value / (newMeter.maxValue - newMeter.minValue);

  addGameObject(manager, newMeter);

  let tObj = createAndAddLocalTextObject(
    manager,
    getZeroStaticEntity(),
    newMeter.label,
    TEXT_STYLE.RESTVALUES,
    2,
    true,
  );

  tObj.moveMode = MoveMode.ANCHORED;
  tObj.anchoredPos = anchoredPos(v2(0, 0.5), v2(10, 0), v2(0, 0.5));
  newMeter.labelText = tObj;
  setParent(tObj, newMeter);

  setVisibilityState(newMeter, VisibilityState.DEFAULT);

  return newMeter;
}

// function createProgressMeterView(renderGroup: RenderGroup, meter: ProgressMeter) {
//   {
//     const width = meter.width * meter.valuePercentage;
//     const xOffset = (meter.width - width) / 2;
//     let rect = addNextRenderItemToGroup(RenderItemType.rect, renderGroup) as RenderRect;
//     rect.position = v2(-xOffset, 0);
//     rect.width = width;
//     rect.height = meter.height;
//     rect.shapeStyle = meter.styleFill;
//   }
//   {
//     let rect = addNextRenderItemToGroup(RenderItemType.rect, renderGroup) as RenderRect;
//     // rect.position = v;
//     rect.width = meter.width;
//     rect.height = meter.height;
//     rect.shapeStyle = meter.highlighted ? meter.styleBackgroundHL : meter.styleBackground;
//   }
// }
